import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import MailIcon from "@material-ui/icons/Mail";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import * as React from "react";
import { useHistory } from "react-router";

const sideBarItemList = [
  {
    text: "Users",
    link: "/",
  },
  {
    text: "Cashout Requests",
    link: "/cashout-request",
  },
  {
    text: "Upgrad Request",
    link: "/upgrad-request",
  },
  {
    text: "Settings",
    link: "/setting",
  },
  {
    text: "Jobs",
    link: "/jobs",
  },
  {
    text: "Withdraw-Setting",
    link: "/withdraw-setting",
  },
];

export default function LeftSideBar({ open, setOpen, anchor }) {
  const history = useHistory();

  const changeRoute = (path) => {
    history.push(path);
  };

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
      onClick={setOpen(false)}
      onKeyDown={setOpen(false)}
    >
      <List>
        {sideBarItemList.map((itm, index) => (
          <ListItem button onClick={() => changeRoute(itm.link)}>
            <ListItemIcon>
              {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
            </ListItemIcon>
            <ListItemText primary={itm.text} />
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        <ListItem button>
          <ListItemText primary="Logout" />
        </ListItem>
      </List>
      {/* <List>
        {["All mail", "Trash", "Spam"].map((text, index) => (
          <ListItem button key={text}>
            <ListItemIcon>
              {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
            </ListItemIcon>
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List> */}
    </Box>
  );

  return (
    <div>
      <SwipeableDrawer
        anchor={anchor}
        open={open}
        onClose={setOpen(false)}
        onOpen={setOpen(true)}
      >
        {list(anchor)}
      </SwipeableDrawer>
    </div>
  );
}
